import { createGlobalStyle } from "styled-components";
import Sprite from "../images/Sprite.svg";

export const GlobalStyle = createGlobalStyle`
  body {
    background-color: #ffffff;
    background-image: url(${Sprite});
    background-repeat: repeat;
    background-position: top center;
    background-size: 300px;
    height: 100vh;
  }

  #root {
    height: 100vh;
    display: flex;
    flex-direction: column;
  }
`;
